import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-qep-toggle',
  templateUrl: './qep-toggle.component.html',
  styleUrls: ['./qep-toggle.component.scss']
})
export class QepToggleComponent {

  @Input() isChecked = false;
  @Input() toggleLabel: string;
  @Output() valueChanged: EventEmitter<boolean> = new EventEmitter();

  checkChanged(ev) {
    this.valueChanged.emit(ev.target.checked);
  }

}
